import { Button, Group, Stack, Text } from '@mantine/core';
import { notifications } from '@mantine/notifications';

const VERSION_URL = '/version.json';
const POLL_INTERVAL_MS = 5 * 60 * 1000;
const MIN_CHECK_GAP_MS = 30 * 1000;
const NOTIFICATION_ID = 'app-update-available';

let lastCheckedAt = 0;
let notified = false;

async function fetchDeployedVersion(): Promise<string | null> {
  try {
    const res = await fetch(`${VERSION_URL}?t=${Date.now()}`, {
      cache: 'no-store',
      credentials: 'omit',
    });
    if (!res.ok) return null;
    const body = (await res.json()) as { version?: unknown };
    return typeof body.version === 'string' ? body.version : null;
  } catch {
    return null;
  }
}

function announceUpdate() {
  if (notified) return;
  notified = true;
  notifications.show({
    id: NOTIFICATION_ID,
    title: 'New version available',
    color: 'blue',
    autoClose: false,
    withCloseButton: true,
    onClose: () => {
      notified = false;
    },
    message: (
      <Stack gap="xs">
        <Text size="sm">
          A newer build of the backoffice has been released. Reload to get it -
          unsaved changes will be lost.
        </Text>
        <Group justify="flex-end">
          <Button size="xs" onClick={() => window.location.reload()}>
            Reload
          </Button>
        </Group>
      </Stack>
    ),
  });
}

async function check() {
  const now = Date.now();
  if (now - lastCheckedAt < MIN_CHECK_GAP_MS) return;
  lastCheckedAt = now;
  const deployed = await fetchDeployedVersion();
  if (deployed && deployed !== __BUILD_VERSION__) announceUpdate();
}

export function startVersionCheck() {
  setInterval(check, POLL_INTERVAL_MS);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') check();
  });
  window.addEventListener('focus', check);
}
